const AC = 'AC'
const SOLAR = 'SOLAR'
const BATTERY = 'BATTERY'

const objects = {
    [AC]: {
        type: AC,
        label: 'AC',
    },
    [SOLAR]: {
        type: SOLAR,
        label: 'Solar',
    },
    [BATTERY]: {
        type: BATTERY,
        label: 'Battery',
    },
}

export default Object.freeze(objects)
export const ordered = Object.freeze([objects.BATTERY, objects.AC, objects.SOLAR])

export const byValue = (value) => {
    return objects[value?.toUpperCase()]
}
